import { Section } from '../../../layout';
import type { IContactAddress } from '@trii/types/dist/Contacts';
import type { IBusiness, IContact } from '@trii/types/dist/Contacts/contacts';
import useEditModal from './hooks/useEditModal';
import { EditModal, ContactMethod } from './components';
import { useEditEntity } from '../../../context/EditEntityContext';
import { useTranslationContext } from '../../../context/TranslationContext';

type OwnerData = IContact | IBusiness;

interface Props {
  ownerData: OwnerData;
}

const ContactInformation = ({ ownerData }: Props) => {
  const { isOpen, title, openModal, closeModal } = useEditModal();
  const { editEntity } = useEditEntity();
  const t = useTranslationContext();

  const phones: IContactAddress[] = editEntity.field.phoneNumbers;
  const emails: IContactAddress[] = editEntity.field.emails;
  const facebook: IContactAddress[] = editEntity.field.imsFacebooks;
  const whatsapp: IContactAddress[] = editEntity.field.imsWhatsapp;
  const mercadolibre: IContactAddress[] = editEntity.field.imsMercadolibre;
  const webchat: IContactAddress[] = editEntity.field.imsWebchats;
  const instagram: IContactAddress[] = editEntity.field.imsInstagrams;
  const rcs: IContactAddress[] = editEntity.field.imsRCS;

  const contactMethods = [
    {
      key: 'phones',
      title: t('conversations.contactDetails.phones'),
      items: phones,
      isPhone: true,
      modalTitle: 'Phones',
      visible: true,
    },
    {
      key: 'emails',
      title: 'Emails',
      items: emails,
      modalTitle: 'Emails',
      visible: true,
    },
    {
      key: 'facebook',
      title: 'Facebook',
      items: facebook,
      modalTitle: 'Facebook',
      visible: true,
    },
    {
      key: 'whatsapp',
      title: 'Whatsapp',
      items: whatsapp,
      modalTitle: 'Whatsapp',
      visible: true,
    },
    {
      key: 'rcs',
      title: 'RCS',
      items: rcs,
      modalTitle: 'RCS',
      visible: rcs.length > 0,
    },
    {
      key: 'mercado-libre',
      title: 'Mercado libre',
      items: mercadolibre,
      modalTitle: 'Mercado libre',
      visible: true,
    },
    {
      key: 'webchat',
      title: 'Webchat',
      items: webchat,
      modalTitle: 'Webchat',
      visible: true,
    },
    {
      key: 'instagram',
      title: 'Instagram',
      items: instagram,
      modalTitle: 'Instagram',
      visible: true,
    },
  ];

  return (
    <>
      <Section title={t('conversations.contactDetails.contactInformation')}>
        <div className="grid grid-cols-1 gap-3">
          {contactMethods
            .filter((method) => method.visible)
            .map((method) => (
              <ContactMethod
                key={method.key}
                handleEdit={() => openModal(method.modalTitle)}
                title={method.title}
                methodItems={method.items}
                isPhone={method.isPhone}
                owner={ownerData}
              />
            ))}
        </div>
      </Section>
      <EditModal open={isOpen} onClose={closeModal} title={title} />
    </>
  );
};

export default ContactInformation;
